import {  useState } from "react";

import {  Box, IconButton,  Stack  } from "@mui/material";

import { useAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";

import { useDeleteAnnotationMutation } from "api/virtual-tour/mutations/useDeleteAnnotationMutation";
import { useEditAnnotationMutation } from "api/virtual-tour/mutations/useEditAnnotationMutation";

import "../../components/index.css";
import Comment from "components/CommentEditor/Comment";
import { useGetWorkspaceUsersQuery } from "api/workspace/queries/useGetWorkspaceUsersQuery";
import { useParams } from "react-router-dom";
import { useWorkspaces } from "contexts/WorkspacesContext";
import TextAnnotation from "components/CommentEditor/TextAnnotation";
import { useAddAnnotationCommentMutation } from "api/virtual-tour/mutations/useAddAnnotationCommentMutation";
import CloseIcon from '@mui/icons-material/Close';
import { NewComment } from "./NewComment";
import { fillInMissingUserInWorkspaceUsers, WorkspaceUserWithPossibleMissingValues } from "../../types/workspaceUser";

type AnnotationsProps = {
  annotation: VirtualTourAnnotation | null;
  onClose: () => void;
  tourId: string;
};
export const DisplayAnnotation = ({
  annotation,
  onClose,
  tourId,
}: AnnotationsProps) => {

  const { workspaceSlug } = useParams();


  const { user } = useAuth0();
  const isOwner = user?.sub === annotation?.author.id;
  const [isMouseOver, setIsMouseOver] = useState(false);
  const { mutate: deleteAnnotation, isPending: isDeletePending } =
    useDeleteAnnotationMutation();
  const { mutate: editAnnotation, isPending: isEditPending } =
    useEditAnnotationMutation();
  const [isExpanded, setIsExpanded] = useState(false);
  const wantToShowMore = (annotation?.message || "")?.length > 35;


  const {
    activeWorkspace: { id: workspaceId },
  } = useWorkspaces();
  const { data } = useGetWorkspaceUsersQuery(workspaceId);

  const workspaceUsers = fillInMissingUserInWorkspaceUsers((data || []) as WorkspaceUserWithPossibleMissingValues[]);

  const comments = annotation?.virtualTourAnnotationComments || [];

  const { mutate: addComment, isPending } = useAddAnnotationCommentMutation();

  const handleSubmit = (formattedText: string, mentions: string[], cleanMessage: string, files?: File[]) => {
    addComment({
      annotationId: annotation?.id || "",
      type: "TEXT",
      message: formattedText,
      cleanMessage: cleanMessage,
      version: 2,
      mentions: mentions,
      metadata: {
        attachments: files?.map(file => ({
          filename: file.name || ""
        })) || [],
      }
    }, {
      onSuccess: () => {
        toast("Comment added successfully!", {
          type: "success",
        });
      },
    })
  };

  if (!annotation) return null;

  return (
    <Box sx={{
      width: '25rem',
      height: '80vh',
      backgroundColor: '#212121',
      borderRadius: '16px',
      border: '1px solid #313131',
      padding: '1rem',
      position: 'absolute',
      top: '50%',
      right: '2rem',
      transform: 'translate(0, -50%)',
      zIndex: 1000,
    }}>
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: -20,
          right: -20,
          backgroundColor: '#212121',
          border: '1px solid #414141',
          color: 'rgba(255, 255, 255, 0.8)',
          '&:hover': {
            backgroundColor: '#313131',
            color: 'white'
          },
          zIndex: 1001,
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <Stack sx={{
        height: '100%',
        width: '100%',
        gap: '.75rem',
      }}>
        <TextAnnotation annotation={annotation} users={workspaceUsers || []} tourId={tourId} />
        <Stack sx={{
          flexGrow: 2,
          height: '100%',
          width: '100%',
          gap: '.4rem',
          alignItems: 'flex-end',
          overflowY: 'auto',
          overflowX: 'hidden',
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: '#212121',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#414141',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#515151',
          },
        }}>
          {comments.map((comment, index) => (
            <Comment key={index} comment={comment} users={workspaceUsers || []} />
          ))}
        </Stack>
        <Stack direction="row" sx={{ width: '100%' }}>
          {/* <CommentEditor onSubmit={handleSubmit} users={workspaceUsers || []} /> */}
          <NewComment annotation={annotation} type="comment" />
        </Stack>
      </Stack>
    </Box>
  );
};
